<a href="{{value}}" class="col-md-6 col-form-label" target="_blank">
  {{title}}
</a>